import {
  type PosthogExceptionEntry,
  exceptionValue,
  frameNameIncludes,
} from "./posthog-exception-types";

const PWMGR_FN_NEEDLE = "_logEvaluatedStringInfo";

export function isPasswordManagerExtensionNoise(
  first: PosthogExceptionEntry,
): boolean {
  const value = exceptionValue(first);
  if (!value.includes("Right-hand side of 'instanceof' is not an object")) {
    return false;
  }
  const frames = first.stacktrace?.frames ?? [];
  return frames.some((frame) => frameNameIncludes(frame, PWMGR_FN_NEEDLE));
}

const WALLET_PROVIDER_ASSIGNMENT_VALUE =
  "undefined is not an object (evaluating 'window.ethereum.selectedAddress = undefined')";

export function isWalletExtensionInjectedScriptPosthog(
  first: PosthogExceptionEntry,
): boolean {
  if (exceptionValue(first) === WALLET_PROVIDER_ASSIGNMENT_VALUE) return true;
  const frames = first.stacktrace?.frames ?? [];
  return frames.some((frame) => {
    const file = frame.filename ?? frame.abs_path ?? "";
    return file.includes("injectedScript.bundle.js");
  });
}

const ADWARE_WINDOW_INJECTION_PATTERN =
  /window\[window\.\w+\.jsb\]\[window\.\w+\.func\]/;

export function isAdwareWindowInjectionValue(value: string): boolean {
  return ADWARE_WINDOW_INJECTION_PATTERN.test(value);
}

const MALWARE_FETCH_VALUE_PATTERN = /^Failed to fetch \([^)]+\)$/;

function frameIsAnonymousOrMissing(frame: {
  filename?: string;
  abs_path?: string;
}): boolean {
  const file = frame.filename ?? frame.abs_path ?? "";
  return file === "" || file === "<anonymous>";
}

function frameIsThirdPartyForMalwareFetch(frame: {
  filename?: string;
  abs_path?: string;
}): boolean {
  if (frameIsAnonymousOrMissing(frame)) return true;
  const file = frame.filename ?? frame.abs_path ?? "";
  return file.includes("extensions/replay") || file.includes("posthog-js");
}

export function isMalwareFetchInjectionPosthog(
  first: PosthogExceptionEntry,
): boolean {
  if (!MALWARE_FETCH_VALUE_PATTERN.test(exceptionValue(first))) return false;
  const frames = first.stacktrace?.frames ?? [];
  if (frames.length === 0) return false;
  return frames.every(frameIsThirdPartyForMalwareFetch);
}
